export type LanguageCode = 'nl' | 'en' | 'de';

type Language = {
	code: LanguageCode;
	file: `${LanguageCode}.ts`;
};

const languages: Language[] = [
	{
		code: 'nl',
		file: 'nl.ts',
	},
	{
		code: 'en',
		file: 'en.ts',
	},
	{
		code: 'de',
		file: 'de.ts',
	},
];

export default languages;
